const STORAGE_KEY = "tm_home_app_usage";

function asStr(x) {
  return String(x ?? "").trim().toLowerCase();
}

function readUsageMap() {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeUsageMap(map) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {}
}

export function trackAppOpen(appKey) {
  const key = asStr(appKey);
  if (!key) return;
  const map = readUsageMap();
  const prev = map[key] && typeof map[key] === "object" ? map[key] : {};
  map[key] = {
    open_count: Number(prev.open_count || 0) + 1,
    last_opened_at: new Date().toISOString(),
  };
  writeUsageMap(map);
}

